var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('router-link',{attrs:{"to":{
		path: '/species',
		query: {
          id: _vm.id,
          did: _vm.did,
          latin_name: _vm.latin_name,
          plant_name: _vm.plant_name,
          cover_url: _vm.cover_url
		},
       }}},[_c('a',{staticClass:"backLink"},[_vm._v("Back")])]):_vm._e(),_c('div',{staticClass:"menu",attrs:{"id":"menu"}},[_c('div',{staticClass:"content1"},[_c('div',{staticClass:"btn"},[_c('ul',[_c('li',{staticClass:"black"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_c('li',{staticClass:"ww"},[_vm._v("|")]),_c('li',[_c('router-link',{attrs:{"to":{
                  path: '/speciesblast',
                  query: { url: _vm.url, blastPort: _vm.blastPort },
                }}},[_vm._v("Blast")])],1),_c('li',{staticClass:"ww"},[_vm._v("|")]),_c('li',[_c('router-link',{attrs:{"to":"/primer"}},[_vm._v("Primer design")])],1)])])])]),_c('div',{staticClass:"content"},[_c('iframe',{attrs:{"width":"100%","frameborder":"0","height":"505","src":_vm.url+':'+_vm.blastPort}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }